import type { StructuredSearchSchema } from "./structured-search-schema";

import * as requestLogsOlderData from "@/routes/request-logs/search/older-data";
import * as tracesOlderData from "@/routes/traces/search/older-data";
import type { Workspace } from "@/types/workspaces";

type OlderDataModule = typeof requestLogsOlderData;

const OLDER_DATA_BY_SCHEMA_ID: Record<string, OlderDataModule> = {
  requests: requestLogsOlderData,
  traces: tracesOlderData,
};

export const getOlderDataModule = (schema: StructuredSearchSchema): OlderDataModule =>
  OLDER_DATA_BY_SCHEMA_ID[schema.id] ?? requestLogsOlderData;

export const getCutoverDateForSchema = (
  schema: StructuredSearchSchema,
  workspace: Workspace | undefined,
): string | null | undefined => {
  if (schema.id === "traces") {
    return workspace?.traces_search_cutover_date;
  }

  return workspace?.search_cutover_date;
};
